<template>
    <div class="index">
        <div class="topic cf">

            <div class="topic-left fl">

                <layout-topic-item
                    v-for="(item,index) in topicList"
                    :key="'topic-item-'+index"
                    :data="item"
                />

            </div>

            <layout-right-list :data="info" />

        </div>
        <div v-if="count > 10" class="pagination-box">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="count"
                @current-change="changePage"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import mixin from "./mixin/mixin";
import LayoutTopicItem from '../../layout/layout-topic-item/main';
import LayoutRightList from "@/layout/layout-right-list/main";
export default {
    name: "topic",
    mixins: [mixin],
    components: {
        LayoutRightList,
        LayoutTopicItem,
    }
}
</script>

<style scoped src="./style.css"></style>
